import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SessionState {
  replacementClientsAvailable: boolean | null;
  replacementClientsAvailabilityLoading: boolean;
}

const initialState: SessionState = {
  replacementClientsAvailable: null,
  replacementClientsAvailabilityLoading: false,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    startReplacementClientsAvailabilityCheck: (state) => {
      state.replacementClientsAvailabilityLoading = true;
    },
    setReplacementClientsAvailable: (state, action: PayloadAction<boolean>) => {
      state.replacementClientsAvailable = action.payload;
      state.replacementClientsAvailabilityLoading = false;
    },
    resetSession: () => initialState,
  },
});

export const {
  startReplacementClientsAvailabilityCheck,
  setReplacementClientsAvailable,
  resetSession,
} = sessionSlice.actions;
export default sessionSlice.reducer;
